module.exports = __webpack_public_path__ + "img/tet20202_mobile.53223b4e.png";